<template>
  <div class="recruitmentBanner">
    <div class="publicCon">
      <div class="publiceTit">
        <div class="title">
          <p class="titleBg">{{bannerInfo.eng}}</p>
          <p class="titleCon">{{bannerInfo.name}}</p>
          <span class="line"></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ["bannerInfo"],
    data () {
      return {
      }
    },
    created () {
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/recruitmentBanner/index.vue